module.exports = __webpack_public_path__ + "img/2.3bde6d21.png";